import { Field } from "@progress/kendo-react-form";
import { FormRegion } from "../../../../components/formregion";
import { FormDropDownList } from "../../../../forms/form-components";
import { useDispatch, useSelector } from "react-redux";
import {
  setFormValue,
  setListOfTables,
} from "../../../../redux/slices/createdatasetpageslice";
import { useEffect } from "react";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

const ChooseTable = (props) => {
  //#region state

  const { formValues } = props;
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const createDatasetState = useSelector((state) => state.createDatasetPage);
  const lstOfTable = createDatasetState.lst_of_tables;
  //#endregion

  //#region functions
  const handleOnChangeField = (id, value) => {
    dispatch(setFormValue({ id, value }));
  };
  //#endregion

  return (
    <FormRegion>
      <div className="form-group form-group-1" style={{ marginBottom: "50px" }}>
        <Field
          id={"Table"}
          name={"Table"}
          label={t("datasets.create.select")}
          component={FormDropDownList}
          data={lstOfTable}
          onChange={(e) => handleOnChangeField("Table", e.value)}
        />
      </div>
    </FormRegion>
  );
};

export default ChooseTable;
